export default __webpack_public_path__ + "static/media/Magadhi_cm_1.d0b31575.mp3";